export default "__VITE_ASSET__eBxYusS7__"